import { createConsumer, createSubscriber, IEvent } from '@cian/events-log';

import { EAlertType } from '../../repositories/header-frontend/v3/get-header-microfrontend/microfrontend/api/open-auth-modal';
import { TThunkAction } from '../../types/redux';

export { EAlertType };

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
  onSuccess?(): void;
}

const TOPIC_USER = 'user';

export function requestAuthentication({ alert, onSuccess }: IRequestAuthenticationParameters = {}): TThunkAction {
  return (_dispatch, _getState, context) => {
    const { microfrontendsAPI } = context;

    if (!microfrontendsAPI) {
      return;
    }

    if (onSuccess) {
      const consumer = createConsumer({ topic: TOPIC_USER });
      const userSubscriber = createSubscriber((event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          onSuccess();
          consumer.destroy();
        }
      });

      consumer.subscribe(userSubscriber);
    }

    void microfrontendsAPI.header.openAuthModal({
      autoRefresh: !onSuccess,
      alert: alert ?? null,
      useDefaultView: false,
      viewData: null,
      source: null,
    });
  };
}
